import Styled from 'styled-components';
import {NOVA_UNREAD_HIGHLIGHT} from '../../../forecast-app/shared/components/nova-invocation/styleTokens';

export const getBackgroundColorStyle = props => {
	if (props.isSelected) return '#f0e7fc';
	else if (props.novaUnread) return NOVA_UNREAD_HIGHLIGHT;
	else if (props.isFavoured) return '#fefdf3';
	else return '#fff';
};

// The ordinary hover gray is meant to be a neutral "you're pointing at this row" cue, which makes
// sense to flatten over the favourited/selected tints too - but an unread Nova run is a status a
// person is actively scanning the list for, not a passive tint, so hovering must not hide it.
export const getHoverBackgroundColorStyle = props => {
	if (props.novaUnread) return getBackgroundColorStyle(props);
	return '#f3f3f3';
};

const getBorderColor = props => {
	if (props.isSelected) return '#6e0fea';
	if (props.isFavoured) return '#e6e6e6';
	else return '#e6e6e6';
};

export const TaskItemsContainer = Styled.div`
	margin-right: 16px;
`;

export const LoaderContainer = Styled.div`
	width: 100%;
	height:237.19px;
`;
export const Line = Styled.div`
	overflow: hidden;
	position: relative;
	height: auto;
`;
export const TaskContainer = Styled.div`
	
`;
export const TableRow = Styled.div`
	outline: none;
	box-sizing: border-box;
	display: flex;
	justify-content: stretch;
	align-items: center;
	height: 48px;
	overflow:hidden;
	
`;

export const TableRowHeader = Styled(TableRow)`
	font-size: 9px;
	line-height: 1;
	letter-spacing: 1px;
	color: #a1a1a1;
	font-weight: 500;
	margin-right: 16px;
	text-transform: uppercase;
	z-index:1;
	background:${props => (props.isInContainer ? '#f3f3f3' : '#f5f5f8')}; 
	${props => (props.stickyTopPosition !== null ? 'position:sticky;' : '')};
	${props => (props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '')};
	border-bottom:  ${props => '1px solid ' + getBorderColor(props)};
	width: 100%;
	height: 40px;
	// padding-bottom:8px;
	>div{
		border-radius: 1px;
		>div{
			padding-top: 8px;
			padding-bottom: 8px;
		}
	}
`;

export const TaskItemTableRow = Styled(TableRow)`
	font-size: 13px;
	position: relative;
	color: #535353;
	border-bottom:  ${props => '1px solid ' + getBorderColor(props)};			
	>div{
		/*border to on each sub element because of the corner at the end of the row*/
		background:${props => getBackgroundColorStyle(props)};
		transition: background-color 0.2s ease;		
		&.context-menu{
			>span {
				opacity:0;
			}
		}
		.time-registration-icon{
				opacity:0;
		}
	}
	
	${({disabled}) =>
		disabled &&
		`
		>div{
			background: #f3f3f3;
		}
	`}
	
	&:hover{
		>div{
			/*border to on each sub element because of the corner at the end of the row*/
			background: ${props => getHoverBackgroundColorStyle(props)};
			transition: background-color 0.2s ease;
			&.context-menu{
				>span {
					opacity:1;
				}
			}
			.time-registration-icon{
				opacity:1;
			}
		}
	}
	.clickable{
		cursor: pointer;
		text-decoration: none;
		color: #535353;
		outline:none;
		&:hover{
			color: #6f49c5;
		}
	}
`;

export const NumberColumn = Styled.span`
	text-align:right;
	flex:1;
`;

export const TableHeaderItemContainer = Styled.div`
	display: flex;
	align-items: center;
	cursor:${props => props.sortable && 'pointer'};;
	p  {
		display: inline-block;
	}
	color: ${props => props.sort && '#6e0fea'};
	&:hover {
		color: ${props => props.sortable && '#6e0fea'};
		transition:color 0.2s ease;
	}
`;

const TableRowItem = Styled.div`
	box-sizing: content-box;
	padding-top: 0;
	padding-bottom: 0;
	height: 100%;
	padding-left: 16px;
    user-select: none; //avoid the selection when resizing	
	span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	/*TODO delete when a propper dropdown has been made*/
	.drop-down-v2, .unfocused-assigned-container, .focused-assigned-container{
		box-sizing:border-box;
	}
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const StaticTableRowItem = Styled(TableRowItem)`
	min-width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	max-width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	display: flex;
	justify-content: flex-start;
	align-items: center;
	
`;
export const StaticTableRowItemMultiple = Styled(StaticTableRowItem)`
	justify-content: flex-end;
`;

export const InvisibleTableRowItem = Styled(StaticTableRowItem)`
	padding-left:0;
`;

export const CornerTableRowItem = Styled(TableRowItem)`
	min-width: ${props => (props.width ? props.width + 'px' : 'auto')};
	max-width: ${props => (props.width ? props.width + 'px' : 'auto')};
	width: ${props => (props.width ? props.width + 'px' : 'auto')};
	height: 100%;
	background:none;
	margin:0;
    padding:0;
`;

export const GrowableTableRowItem = Styled(TableRowItem)`
	flex: 1;
	height: 100%;
	display: grid;
	align-content: space-evenly;
	align-items: center;
	min-width:200px;
	${props => 'width:' + props.width + 'px;'};
	${props => (props.resizing ? 'background:rgba(0, 0, 0, 0.05);' : null)}
	
	div{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	span{
		margin-right:5px;
	}
	.header{
		height:100%;
		display:flex;
		justify-content:space-between;
	}
	 .resizer{
		opacity:${props => (props.resizing ? 1 : 0)};
	}
	&:hover{
		background:rgba(0, 0, 0, 0.05);
		.resizer{
			opacity:1;
		}
	} 
`;

export const Resizer = Styled.div`
	width:4px;
	font-weight:900;
	cursor:col-resize;
	display: flex;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.2);
	height:100%;
	border-radius: 1px;
`;

export const Container = Styled.div`
	display: flex;
	flex-direction: column;
`;

export const NestedDropdownStyle = Styled.div`
	margin: 5px 0 0 0;
	width: 340px;
`;
export const Row = Styled.div`
	margin-bottom: ${props => (props.last ? '0px' : '24px')};
`;

export const Text = Styled.p`
	margin: 0;
	padding: 0;
	font-size: 13px;
	color: #535353;
	max-width: 702px;
`;

export const TimeRegPopup = Styled.div`
	margin-right:5px;
	height: 20px;// the height of the svg
`;

export const TaskParentName = Styled.div`
	color: #A5A5AE;
	font-size: 11px;
`;
